import React from 'react';
import { TFunction } from 'react-i18next';
import { LeasingCalculatorGeneralData } from '../generalData';
import { LeasingCalculatorData } from './LeasingCalculatorData';
import { LeasingCalculatorObjectData } from '../objectData';
import { LeasingCalculatorFinancialData } from '../financialData';
import { LeasingCalculatorOfferData } from '../offerData';
import { LeasingCalculatorProductSelectionData } from '../productSelectionData/components/LeasingCalculatorProductSelectionData';

export interface LeasingCalculatorStepItem {
  name: string;
  key: string | number;
  component: React.ReactNode;
  hideSteps?: boolean;
  hideButtons?: boolean;
  ctaButtonText?: string;
}

export const getLeasingCalculatorSteps = (
  t: TFunction,
  userFormData: LeasingCalculatorData,
  setUserFormData: (formData: LeasingCalculatorData) => void,
  onNextStep: () => void,
  onPreviousStep: () => void,
  onSubmit: () => void,
): LeasingCalculatorStepItem[] => [
  {
    name: t('leasingCalculator.generalData.stepName'),
    key: '1',
    component: (
      <LeasingCalculatorGeneralData
        onChange={setUserFormData}
        defaultValues={userFormData}
        onPreviousStep={onPreviousStep}
        onNextStep={onNextStep}
      />
    ),
  },
  {
    name: t('leasingCalculator.objectData.stepName'),
    key: `2`,
    component: (
      <LeasingCalculatorObjectData
        onChange={setUserFormData}
        defaultValues={userFormData}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
      />
    ),
  },
  {
    name: t('leasingCalculator.financialData.stepName'),
    key: `3`,
    component: (
      <LeasingCalculatorFinancialData
        onChange={setUserFormData}
        defaultValues={userFormData}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
      />
    ),
  },
  {
    name: t('leasingCalculator.productSelectionData.stepName'),
    key: `4`,
    component: (
      <LeasingCalculatorProductSelectionData
        onChange={setUserFormData}
        defaultValues={userFormData}
        onNextStep={onNextStep}
        onPreviousStep={onPreviousStep}
      />
    ),
  },
  {
    name: t('leasingCalculator.offerData.stepName'),
    key: `5`,
    component: (
      <LeasingCalculatorOfferData
        defaultValues={userFormData}
        onPreviousStep={onPreviousStep}
        onSubmit={onSubmit}
      />
    ),
    ctaButtonText: t('leasingCalculator.submitButton'),
  },
];
